import { LoginState } from "./type";

export const getIsUserAuthenticated = (state: LoginState) => state.isAuthenticated;

export const getHasUserAlreadySubmittedInfo = (state: LoginState) => state.isAlreadySubmitted;

export const getIsLoginValid = (state: LoginState) => state.isValidLogin;

export const getMyleCommunicationErrorStatus = (state: LoginState) => state.isHavingIssuesWithConnectionToMyle;


// WEBPACK FOOTER //
// ./src/store/Login/selectors.ts